'use client';

import dynamic from 'next/dynamic';

export const HeaderModalsDynamic = dynamic(() => import('./HeaderModals').then((mod) => mod.HeaderModals), {
  ssr: false,
});
